<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" />

        <action-button type="delete" @click="del(drivingtest.id)" v-if="drivingtest.id && $can('drivingtest-delete') && modal != true" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="drivingtest.coursetypegroup_id"
                  ref="coursetypegroup_id"
                  v-model="drivingtest.coursetypegroup_id"
                  class="required-field"
                  v-validate="'required'"
                  @change="courseGroupChange(drivingtest.coursetypegroup_id)"
                  :items="coursetypegroups"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypegroups.stitle')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('drivingtest.coursetypegroup_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="drivingtest.coursetype_id"
                  ref="coursetype_id"
                  v-model="drivingtest.coursetype_id"
                  class="required-field"
                  v-validate="'required'"
                  @change="courseTypeChange(drivingtest.coursetype_id)"
                  :items="coursetypes"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypes.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('drivingtest.coursetype_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="drivingtest.class_id"
                  v-model="drivingtest.class_id"
                  v-validate="''"
                  :items="classes"
                  item-text="name"
                  item-value="id"
                  :label="$t('classes.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('course.class_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="drivingtest.course_id"
                  ref="course_id"
                  v-model="drivingtest.course_id"
                  @change="courseChange(drivingtest.course_id)"
                  :items="courses"
                  item-text="name"
                  item-value="id"
                  :label="$t('courses.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('drivingtest.course_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="drivingtest.participant_id"
                  v-model="drivingtest.participant_id"
                  class="required-field"
                  v-validate="'required'"
                  :items="participants"
                  item-text="full_name"
                  item-value="id"
                  :label="$t('participants.stitle')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('drivingtest.participant_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="drivingtest.instructor_id"
                  v-model="drivingtest.instructor_id"
                  class="required-field"
                  v-validate="'required'"
                  :items="instructors"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('drivingtests.instructor_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('drivingtest.instructor_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="drivingtest.place"
                  v-model="drivingtest.place"
                  :label="$t('drivingtests.place')"
                  :error-messages="errors.collect('drivingtest.place')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg1 md2 sm6 xs12>
                <v-dialog ref="dialog" v-model="date_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="drivingtest.date"
                      v-model="computedDate"
                      :label="$t('drivingtests.date')"
                      class="required-field"
                      v-validate="'required|validDate'"
                      :error-messages="errors.collect('drivingtest.date')"
                      append-icon="event"
                      @click:append="date_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker color="primary" v-model="drivingtest.date" first-day-of-week="1" :locale="this.$locale_bcp47()">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg1 md2 sm6 xs12>
                <v-dialog ref="dialog" v-model="time_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="drivingtest.time"
                      v-model="computedTime"
                      :label="$t('drivingtests.time')"
                      class="required-field"
                      v-validate="'required|validTime'"
                      :error-messages="errors.collect('drivingtest.time')"
                      append-icon="event"
                      @click:append="time_menu = true"
                      :hint="'Format: ' + TIME_FORMAT"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-time-picker color="primary" v-model="drivingtest.time" format="24hr">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="time_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-select
                  name="drivingtest.status"
                  v-model="drivingtest.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_drivingtest_status()"
                  :label="$t('drivingtests.status')"
                  :error-messages="errors.collect('drivingtest.status')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  name="drivingtest.description"
                  v-model="drivingtest.description"
                  v-validate="'max:1000'"
                  :label="$t('drivingtests.description')"
                  :error-messages="errors.collect('drivingtest.description')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "DrivingTestTypesForm",

  props: ["id", "modal", "start_date", "start_time"],

  data() {
    return {
      page_title: "",
      predata: {},
      drivingtest: {},
      drivingtesttypes: [],
      enrolled_organisations: [],
      participants: [],
      courses: [],
      coursetypes: [],
      coursetypegroups: [],
      instructors: [],
      classes: [],
      date_menu: false,
      time_menu: false,
      dictionary: {
        attributes: {
          "drivingtest.enrolled_organisation_id": this.$t("drivingtests.enrolled_organisation_id"),
          "drivingtest.participant_id": this.$t("drivingtests.participant_id"),
          "drivingtest.course_id": this.$t("drivingtests.course_id"),
          "drivingtest.description": this.$t("drivingtesttypes.description"),
          "drivingtest.class_id": this.$t("drivingtests.class_id"),
          "drivingtest.coursetypegroup_id": this.$t("coursetypegroups.title"),
          "drivingtest.coursetype_id": this.$t("drivingtests.title"),
          "drivingtest.instructor_id": this.$t("drivingtests.instructor_id"),
          "drivingtest.status": this.$t("drivingtests.status"),
          "drivingtest.place": this.$t("drivingtests.place")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.drivingtest, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedDate: {
      get() {
        return this.$dateFormatGetter(this.drivingtest.date)
      },
      set(val) {
        this.$set(this.drivingtest, "date", this.$dateFormatSetter(val))
      }
    },
    computedTime: {
      get() {
        return this.$timeFormatGetter(this.drivingtest.time)
      },
      set(val) {
        this.$set(this.drivingtest, "time", this.$timeFormatSetter(val))
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    let lists = [
      { key: "coursetypegroups", module: "coursetypegroups", query: "show_all=true" },
      { key: "coursetypes", module: "coursetypes", query: "show_all=true" },
      { key: "instructors", module: "users", query: "show_all=true&query_is_instructor=1" },
      { key: "participants", module: "participants", query: "show_all=true&query_tenant_user_status=1" },
      { key: "courses", module: "courses", query: "show_all=true" }
    ]

    axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
      this.coursetypegroups = res.data.coursetypegroups
      this.coursetypes = res.data.coursetypes
      this.instructors = res.data.instructors
      this.participants = res.data.participants
      this.courses = res.data.courses

      // Get DrivingTest
      if (!this.id) {
        this.page_title = this.$t("drivingtests.new_drivingtest")
        this.drivingtest = {
          status: this.$getDefaultDropdown(this.$dd_drivingtest_status()),
          date: this.start_date,
          time: this.start_time
        }

        // JSON stringify and parse to remove variable reactiveness
        this.predata = JSON.parse(JSON.stringify(this.drivingtest))
      } else {
        this.title = this.$t("drivingtests.update_title")

        axios
          .get(this.API_URL + "drivingtest/" + this.id)
          .then((res2) => {
            this.drivingtest = res2.data.data
            this.drivingtest.coursetypegroup_id = this.drivingtest.coursetype.coursetypegroup_id

            // JSON stringify and parse to remove variable reactiveness
            this.predata = JSON.parse(JSON.stringify(this.drivingtest))

            if (this.drivingtest.coursetype_id) {
              this.coursetypes = this.coursetypes.filter((i) => this.drivingtest.coursetypegroup_id == i.coursetypegroup_id)
            }

            if (this.drivingtest.course_id) {
              this.courses = this.courses.filter((i) => this.drivingtest.coursetype_id == i.coursetype_id)
              this.courseChange(this.drivingtest.course_id)
            }

            this.page_title = this.$t("drivingtests.edit_drivingtest", {
              name: this.drivingtest.title
            })
          })
          .catch((err) => console.log(err))
      }
    })
  },

  methods: {
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.drivingtest.id) {
              // Create
              axios
                .post(this.API_URL + "drivingtest", {
                  site: process.env.VUE_APP_DOMAIN,
                  subdomain: vm.SUBDOMAIN,
                  participant_id: this.drivingtest.participant_id,
                  course_id: this.drivingtest.course_id,
                  description: this.drivingtest.description,
                  coursetype_id: this.drivingtest.coursetype_id,
                  instructor_id: this.drivingtest.instructor_id,
                  class_id: this.drivingtest.class_id,
                  date: this.drivingtest.date,
                  time: this.drivingtest.time,
                  status: this.drivingtest.status,
                  place: this.drivingtest.place,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.drivingtest = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.drivingtest))

                      vm.drivingtest.coursetypegroup_id = vm.drivingtest.coursetype.coursetypegroup_id

                      if (vm.drivingtest.coursetype_id) {
                        vm.coursetypes = vm.coursetypes.filter((i) => vm.drivingtest.coursetypegroup_id == i.coursetypegroup_id)
                      }

                      if (vm.drivingtest.course_id) {
                        vm.courses = vm.courses.filter((i) => vm.drivingtest.coursetype_id == i.coursetype_id)
                        vm.courseChange(vm.drivingtest.course_id)
                      }

                      vm.page_title = vm.$t("drivingtests.edit_drivingtest", {
                        name: vm.drivingtest.title
                      })

                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "drivingtest",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.$router.replace(this.BACKEND_URL + `/drivingtests/edit/${vm.drivingtest.id}`).catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "drivingtest", {
                  id: this.drivingtest.id,
                  participant_id: this.drivingtest.participant_id,
                  course_id: this.drivingtest.course_id,
                  description: this.drivingtest.description,
                  coursetype_id: this.drivingtest.coursetype_id,
                  instructor_id: this.drivingtest.instructor_id,
                  class_id: this.drivingtest.class_id,
                  date: this.drivingtest.date,
                  time: this.drivingtest.time,
                  status: this.drivingtest.status,
                  place: this.drivingtest.place
                })
                .then((res) => {
                  vm.drivingtest = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.drivingtest))

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "drivingtest",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },

    courseGroupChange(id, typeId = null) {
      let lists = [
        { key: "coursetypes", module: "coursetypes", query: "show_all=true&query_coursetypegroup_id=" + id },
        { key: "participants", module: "participants", query: "show_all=true" }
      ]

      this.drivingtest.course_id = null

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.coursetypes = res.data.coursetypes
        this.participants = res.data.participants
        this.courses = []

        this.$refs.coursetypegroup_id.focus()
      })

      this.drivingtest.coursetype_id = typeId ? typeId : null
    },
    courseTypeChange(id) {
      let lists = [
        { key: "participants", module: "participants", query: "show_all=true" },
        { key: "courses", module: "courses", query: "show_all=true&query_coursetype_id=" + id },
        { key: "classes", module: "classes", query: "show_all=true&query_coursetype_id=" + id }
      ]

      this.drivingtest.course_id = null

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.participants = res.data.participants
        this.courses = res.data.courses
        this.classes = res.data.classes

        if (this.classes.length == 1) {
          this.drivingtest.class_id = this.classes[0].id
        } else {
          this.drivingtest.class_id = null
        }

        this.$refs.coursetype_id.focus()
      })
    },
    courseChange(id) {
      axios.get(this.API_URL + "participants?show_all=true&query_course_id=" + id).then((res) => {
        this.participants = res.data.data

        this.$refs.course_id.focus()
      })
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "drivingtest/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/drivingtests")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
